import { useJourneysStore } from '../stores/useJourneysStore'

import { Level, Stage } from '@/features/journeys'
import { useModalContext } from '@/shared/contexts/Modal'
import { useUserProgress } from '@/shared/contexts/UserProgress'
import { cn } from '@/shared/lib/utils'
import { StageText, getIcon } from '@/shared/ui/Icons'
import { Tooltip, TooltipTrigger } from '@/shared/ui/tooltip'

import { LevelModal } from './LevelModal'
import { LevelTooltipContent } from './LevelTooltipContent'



interface LevelCheckPointProps {
  stage: Stage
  level: Level
  index: number
  journeyUid: string
}

export const LevelCheckPoint = ({
  level,
  stage,
  index,
  journeyUid
}: LevelCheckPointProps) => {
  const { levelWasFinished } = useUserProgress()
  const isFinishedLevel = levelWasFinished(level.id)

  const { levelIsCurrent } = useJourneysStore()
  const isCurrentLevel = levelIsCurrent(level.id)
  const disabled = !isFinishedLevel && !isCurrentLevel

  const Icon = getIcon(level.icon) || StageText

  let style: React.CSSProperties = {}
  if (disabled) style.filter = 'grayscale(1)'
  if (isCurrentLevel) {
    style = {
      transform: 'scale(1.4)',
      transition: 'all 0.3s ease'
    }
  } else if (isFinishedLevel) {
  }

  const classes = cn('relative flex items-start justify-center h-[120px] ', {
    'left-[-110px] md:left-[-175px]': index % 8 === 0,
    'left-[-75px] md:left-[-120]': index % 8 === 1 || index % 8 === 7,
    'left-[0px] md:left-[0px]': index % 8 === 2 || index % 8 === 6,
    'left-[75px] md:left-[120]': index % 8 === 3 || index % 8 === 5,
    'left-[110px] md:left-[175px]': index % 8 === 4,
    '[&_svg]:drop-shadow-[0_4px_4px_rgba(255,255,255,0.5)]': isCurrentLevel
    // 'hover:[&_svg]:drop-shadow-[0_4px_4px_rgba(0,0,0,0.25)]': !isCurrentLevel
  })

  const { openModal } = useModalContext()

  const handleClick = () => {
    openModal(
      {
        modal: LevelModal
      },
      {
        level,
        stage,
        disabled,
        journeyUid
      }
    )
  }

  return (
    <div key={level.id} id={`level-${level.uid}`} className={classes}>
      {isCurrentLevel && <LevelTooltipContent />}
      <div className="relative">
        {/* {isFinishedLevel && (
          <img
            src="/icons/completed-light.svg"
            alt={`${level.name} concluído`}
            className="size-11 absolute -bottom-3 -left-1 select-none pointer-events-none z-10"
            width={46}
            height={46}
          />
        )} */}
        <Icon className="cursor-pointer" onClick={handleClick} style={style} />
      </div>
    </div>
  )
}
